import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import {
  ServicesSection,
  ProcessSection,
} from '@/components/sections'

/**
 * Services Page Component
 * Details about services offered and the process
 */
export const ServicesPage = () => {
  return (
    <Box>
      <Seo
        title="Services"
        description="Explore Leru Systems' website design services and our proven process for building fast, mobile-friendly, lead-generating websites for plumbing companies."
        path="/services"
      />
      <ServicesSection />
      <ProcessSection />
    </Box>
  )
}
